import React from 'react'
import {BsLinkedin, BsGithub} from 'react-icons/bs'
import './Footer.css'
const FooterSection = () => {
  return (
    <div>
      <footer className='footer' id='footer'>
       <div className="container">
        <div className="footer-c">
            <h3>Copyright © 2023. All rights are reserved</h3>
        </div>
        <div className="footer-social">
        <a href="https://www.linkedin.com/in/muhammad-bilal-ahmad-6aa532224/" target='-blink'>< BsLinkedin style={{fontSize:'1.5rem',color:'#fff'}}/></a>
        <a href="https://github.com/Bilal7659" target='-blank'><BsGithub style={{fontSize:'1.5rem',color:'#fff'}}/></a>
        </div>
       </div>
      </footer>
    </div>
  )
}

export default FooterSection
